<template>
  <section
    id="heading"
    :style="{ paddingBottom: '.75rem' }">
    <a-flex
      v-if="apartmentId || $slots.breadcrumbAside"
      class="heading-breadcrumb-row"
      justify="space-between"
      align="center"
      gap="small"
      wrap="wrap">
      <a-breadcrumb v-if="apartmentId">
        <a-breadcrumb-item>
          <router-link :to="getRoutePath(apartmentId)">
            {{ apartmentName }}
          </router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item>
          {{ planName.length ? planName : `${defaultName} ${id}` }}
        </a-breadcrumb-item>
      </a-breadcrumb>
      <div
        v-if="$slots.breadcrumbAside"
        class="heading-breadcrumb-aside">
        <slot name="breadcrumbAside" />
      </div>
    </a-flex>

    <div class="heading-container">
      <a-flex
        justify="space-between"
        wrap="wrap">
        <a-flex
          wrap="wrap"
          align="baseline"
          gap="small">
          <a-typography-title
            :style="{marginBottom: '0'}"
            :level="4">
            <span
              v-if="!isEditModeEnabled"
              :style="{ lineHeight: '32px' }">{{ planName.length ? planName : `${defaultName} ${id}` }}</span>

            <form
              v-if="isEditModeEnabled"
              @submit.prevent="submitEdit">
              <a-space align="center">
                <a-input
                  v-model:value="newName"
                  placeholder="Название планировки"
                  :style="{ maxWidth: '300px' }" />
                <check-circle-outlined
                  :style="{ color: '#52c41a', marginLeft: '1rem' }"
                  @click="submitEdit" />
                <close-circle-outlined
                  :style="{ color: '#f5222d', marginLeft: '1rem' }"
                  @click="cancelEdit" />
              </a-space>
            </form>

            <form-outlined
              v-if="!isEditModeEnabled && canEdit"
              :style="{ color: '#1890ff', marginLeft: '1rem' }"
              @click="setEditMode(true)" />

            <a-tooltip
              v-if="isCrmPlan"
              :title="is3d ? 'Переключиться на 2D' : 'Переключиться на 3D'">
              <layout-outlined
                :style="{ color: '#1890ff', marginLeft: '1rem' }"
                @click="switch3d" />
            </a-tooltip>
          </a-typography-title>
          <slot name="publicSwitch" />
        </a-flex>
        <slot name="actions" />
      </a-flex>
    </div>

    <slot
      name="status" />
  </section>
</template>

<script>
import { defineComponent } from 'vue';
import {
  CheckCircleOutlined, CloseCircleOutlined, FormOutlined, LayoutOutlined,
} from '@ant-design/icons-vue';

export default defineComponent({
  name: 'PlanHeadingWrapper',
  components: {
    CheckCircleOutlined, CloseCircleOutlined, FormOutlined, LayoutOutlined,
  },
  props: {
    id: {
      default: '',
      type: String,
    },
    planName: {
      default: '',
      type: String,
    },
    apartmentName: {
      default: '',
      type: String,
    },
    apartmentId: {
      default: '',
      type: String,
    },
    canEdit: {
      default: false,
      type: Boolean,
    },
    defaultName: {
      default: 'Планировка',
      type: String,
    },
  },
  emits: ['submitName'],
  data() {
    return {
      isEditModeEnabled: false,
      newName: this.planName,
    };
  },
  computed: {
    is3d() {
      return this.$route.name === 'crm-plans3d-show';
    },
    isCrmPlan() {
      return this.$route.name === 'crm-plans3d-show' || this.$route.name === 'crm-plans-show';
    },
  },
  mounted() {
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      this.cancelEdit();
    });
  },
  methods: {
    setEditMode(value) {
      if (this.planName.length) {
        this.newName = this.planName;
      } else {
        this.newName = `${this.defaultName} ${this.id}`;
      }
      this.isEditModeEnabled = value;
    },
    cancelEdit() {
      this.setEditMode(false);
    },
    submitEdit() {
      this.$emit('submitName', this.newName);
      this.setEditMode(false);
    },
    getRoutePath(id) {
      const newRoute = this.$router.resolve({
        name: 'crm-apartments-id',
        params: { id },
      });

      return newRoute.path;
    },
    switch3d() {
      this.$router.push(this.is3d ? `/crm/plans/${this.id}` : `/crm/plans/3d/${this.id}`);
    },
  },
});
</script>

<style scoped>
.heading-breadcrumb-row {
  margin-bottom: 10px;
}

.heading-breadcrumb-aside {
  margin-left: auto;
}
</style>
